export default {"src":"/_next/static/media/WalaWalaValley.3980826b.svg","height":173,"width":207,"blurWidth":0,"blurHeight":0};